export default {
    sqlServer: 'sqlserver',
    backup: 'backup'
};


// WEBPACK FOOTER //
// ./src/js/imageSourceTypes.js